require("turbolinks").start()
require("cookies_eu").start